import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "small-arrow_a121d15e4f2cacd2305974a084484c5f",
  "use": "small-arrow_a121d15e4f2cacd2305974a084484c5f-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"small-arrow_a121d15e4f2cacd2305974a084484c5f\">\n<path d=\"M6.66668 4L5.72668 4.94L8.78002 8L5.72668 11.06L6.66668 12L10.6667 8L6.66668 4Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol